module.exports = __webpack_public_path__ + "img/motionkick__logo.9ee0733a.png";